// extracted by mini-css-extract-plugin
module.exports = {"root":"PermitFilterBtn_root__36JMx"};